import React, { useEffect } from 'react'

import {
  Body1,
  Box,
  ButtonColorVariant,
  ButtonSize,
  Display,
  FlexDirection,
  FontFamily,
  Heading2,
  Modal,
  ModalBody,
  ModalButton,
  ModalClose,
  ModalFooter,
  ModalHeader,
  Space,
  useModal,
} from '@gousto-internal/citrus-react'
import { useDispatch, useSelector } from 'react-redux'

import { useAddCuratedBoxRecipes } from 'routes/Menu/MenuRecipesPage/CuratedBoxWarningModal/useAddCuratedBoxRecipes'
import { useBasket } from 'routes/Menu/domains/basket'
import { getBasketRecipes } from 'selectors/basket'

import { trackDismissCuratedBoxLoseRecipesModal } from '../trackCuratedBox'
import { curatedBoxWarningModalConfig } from './curatedBoxWarningModalConfig'

export const curatedBoxWarningModalName = 'curatedBoxWarningModalName'

export const CuratedBoxWarningModal = ({
  selectedCuratedBox,
  setSelectedCuratedBox,
  hasSeenWarningModal,
}: {
  selectedCuratedBox: any
  setSelectedCuratedBox: (arg: null) => void
  hasSeenWarningModal: boolean
}) => {
  const { removeRecipe } = useBasket()
  const { closeCurrentModal, getCurrentModal } = useModal()
  const dispatch = useDispatch()
  const { addCuratedBoxRecipes } = useAddCuratedBoxRecipes(hasSeenWarningModal)
  const basketRecipes = useSelector(getBasketRecipes)
  const basketRecipesIds =
    basketRecipes && basketRecipes.size ? basketRecipes.keySeq().toArray() : []

  const removeRecipesFromBasket = () => {
    basketRecipesIds.forEach((recipeId: string) => {
      removeRecipe(recipeId)
    })
  }

  const closeModalAndDispatchTracking = (elementClicked: string) => {
    dispatch(trackDismissCuratedBoxLoseRecipesModal(elementClicked))
    closeCurrentModal()
  }
  const confirmCuratedBoxes = () => {
    removeRecipesFromBasket()
  }

  useEffect(() => {
    if (!basketRecipes.size && getCurrentModal() === curatedBoxWarningModalName) {
      addCuratedBoxRecipes(selectedCuratedBox)
      setSelectedCuratedBox(null)
      closeCurrentModal()
    }
  }, [
    addCuratedBoxRecipes,
    closeCurrentModal,
    basketRecipes.size,
    selectedCuratedBox,
    setSelectedCuratedBox,
    getCurrentModal,
  ])

  return (
    <Modal name={curatedBoxWarningModalName}>
      <ModalClose onClose={() => closeModalAndDispatchTracking('cross')} />
      <ModalHeader>
        <Heading2>{curatedBoxWarningModalConfig.modalHeaderText}</Heading2>
      </ModalHeader>
      <ModalBody>
        <Body1 fontFamily={FontFamily.Bold}>{curatedBoxWarningModalConfig.modalTitleText}</Body1>
        <Space size={2} />
        <Body1>{curatedBoxWarningModalConfig.modalBodyText}</Body1>
      </ModalBody>
      <ModalFooter>
        <Box width="100%" display={Display.Flex} flexDirection={FlexDirection.Column}>
          <ModalButton width="100%" size={ButtonSize.Large} onClick={confirmCuratedBoxes}>
            {curatedBoxWarningModalConfig.modalPrimaryButtonText}
          </ModalButton>
          <Space size={2} />
          <ModalButton
            width="100%"
            size={ButtonSize.Large}
            colorVariant={ButtonColorVariant.Secondary}
            onClick={() => closeModalAndDispatchTracking('button')}
          >
            {curatedBoxWarningModalConfig.modalSecondaryButtonText}
          </ModalButton>
        </Box>
      </ModalFooter>
    </Modal>
  )
}
